import { List } from 'antd';

import { useTheme } from 'styled-components';
import useClientListPageController from '../../1_application/client/clientListPageController';
import { ClientSummary } from '../../2_domain/client/client';
import toIDString from '../../lib/util/dateFormatter';
import { getIndex } from '../../lib/util/pagination';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXMiddleButton from '../core/components/buttons/lxMiddleButton';
import LXPageSizeSelector from '../core/components/buttons/lxPageSizeSelector';
import LXSortSelector from '../core/components/buttons/lxSortSelector';
import { XCenter } from '../core/components/center';
import LXList from '../core/components/list/lx_list';
import {
  HeaderPadding,
  ItemPadding,
} from '../core/components/list/lx_list_padding';
import LXPagination from '../core/pagination/lxPagination';
import LXSearcher from '../core/texts/lxSearcher';
import { LXbody, LXCaption, LXh2 } from '../core/texts/lxText';

const ClientListPage = () => {
  const theme = useTheme();
  const c = useClientListPageController();

  const header = (
    <HeaderPadding>
      <Row alignItems="center">
        <LXCaption width={'44px'}>{theme.texts.no}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'128px'}>{theme.texts.clientNo}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'370px'}>{theme.texts.name}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'166px'}>{theme.texts.dateOfBirth}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'108px'}>{theme.texts.gender}</LXCaption>
      </Row>
    </HeaderPadding>
  );

  const listItemBuilder = (client: ClientSummary, idx: number) => {
    return (
      <List.Item onClick={c.navigateToPatientId(client.id)}>
        {/** client detail page */}
        <ItemPadding>
          <Row alignItems="center">
            <LXbody width={'44px'}>
              {getIndex(c.page.pageNumber, c.pagination.pageSize, idx)}
            </LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'128px'}>{client.clientSerial}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'370px'}>{client.name}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'166px'}>{toIDString(client.birthday)}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'108px'}>
              {client.gender === 'MALE' ? theme.texts.male : theme.texts.female}
            </LXbody>
          </Row>
        </ItemPadding>
      </List.Item>
    );
  };

  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        <Row>
          <LXh2>{theme.texts.clientList}</LXh2>
          <SizedBox width={8}></SizedBox>
          <LXh2 fontWeight={400} color={theme.colors.caption}>
            {c.page?.totalElements ?? 0}
          </LXh2>
        </Row>
        <SizedBox height={20}></SizedBox>
        <Row justifyContent="flex-end">
          <LXSearcher
            width={240}
            placeholder={theme.texts.search}
            onChange={c.onSearchTextChangeHandler}
          ></LXSearcher>
          <SizedBox width={16}></SizedBox>
          <LXSortSelector
            value={c.pagination.isAscending ? 'Oldest' : 'Newest'}
            onSelect={c.setFilter}
          ></LXSortSelector>
        </Row>
        <SizedBox height={16}></SizedBox>
        <LXList<ClientSummary>
          datas={c.clients}
          header={header}
          itemBuilder={listItemBuilder}
          loading={c.isLoading}
        ></LXList>
        <SizedBox height={16}> </SizedBox>
        <Row justifyContent="space-between" alignItems="center">
          <Row width="192px">
            <LXMiddleButton onClick={c.navigateToAddPatient}>
              {theme.texts.plusAddNew}
            </LXMiddleButton>
          </Row>
          <LXPagination
            current={c.page?.pageNumber ?? 0}
            pageSize={c.pagination.pageSize}
            total={c.page?.totalElements ?? 0}
            onChange={c.setPageNumber}
          ></LXPagination>
          <Row alignItems="center">
            <LXbody color={theme.colors.caption}>
              {theme.texts.rowsPerPage}
            </LXbody>
            <SizedBox width={10}></SizedBox>
            <LXPageSizeSelector
              value={c.pagination.pageSize}
              onSelect={c.setPageSize}
            ></LXPageSizeSelector>
          </Row>
        </Row>
      </Column>
    </XCenter>
  );
};

export default ClientListPage;
